@import "src/style/lib";

.gallery {
  margin-bottom: 0.5rem;

  .preview,
  .thumbnails {
    img {
      max-width: 100%;
    }

    .thumbnail {
      transition: box-shadow 0.5s ease-out, border-radius 0.5s ease-out,
        border 0.5s ease-out;
      overflow: hidden;
      border: 2px solid transparent;
      border-radius: 1rem;
      box-shadow: 0 1px 1px RGBA(0, 0, 0, 0);
      cursor: pointer;
      will-change: box-shadow;
    }

    .selected {
      box-shadow: 0 1px 1px RGBA(0, 0, 0, 0.5);
      border-radius: 1rem;
      border: 2px solid #fff;
    }
  }

  .preview {
    width: 100%;
    aspect-ratio: 3/2;
    max-height: 90vh;

    @include media-breakpoint-down("sm") {
      height: 400px;
      margin-bottom: 0.5rem;
    }
    position: relative;
    overflow: hidden;
    max-height: 100vh;
    max-height: 100svh;
    border-radius: 1rem;
    /** Safari fix */
    clip-path: inset(0 0 0 0);
    will-change: transform opacity;
  }

  .thumbnails {
    display: grid;
    grid-auto-flow: row;
    grid-template-columns: repeat(auto-fill, minmax(75px, 1fr));
    grid-template-rows: repeat(1, 1fr);
    height: auto;
    margin-top: 0.5rem;
    grid-gap: 0.5rem;

    .thumbnail {
      position: relative;
      aspect-ratio: 1/1;
    }
  }
}
